import { Field, Form, Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import * as Yup from 'yup';
import PrimaryButton from '../../../../components/Buttons/PrimaryButton/PrimaryButton';
import TextField from '../../../../components/TextField/TextField';
import { setFormData } from '../../../../app/slices/formSlice';
import Page from '../../../../components/Page/Page';
import style from './second.module.scss';
import ReactGoogleAutocomplete from 'react-google-autocomplete';

export const Second = ({form, next,back}) => {
        return (
                <>
                <h2 className={clsx(style.page__title)}> Registra il tuo salone</h2>
                <div className={clsx(style.form__fields)}>
                  <Field
                    name="email"
                    label="Inserisci la tua email"
                    component={TextField}
                  />
                  <Field
                    name="password"
                    showPassword
                    label="Crea Password"
                    type="password"
                    component={TextField}
                  />
                <Field
                    name="passwordConfirmation"
                    label="Conferma Password"
                    showPassword
                    type="password"
                    component={TextField}
                  />
    
                </div>
                <div className={clsx(style.form__button)}>
                {/* <PrimaryButton
                    label="Ritorna"
                    onClick={back}
                    
                  /> */}
                  <PrimaryButton
                    type="submit"
                    label="Registrati"
                  />
                </div>
                </>
        )

}